import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,  // Important for cookies/sessions
});

// Auth
export const forgotPassword = (email) => api.post("/auth/forgot-password", { email });
export const resetPassword = (token, new_password) => api.post("/auth/reset-password", { token, new_password });
export const changePassword = (current_password, new_password) => api.post("/auth/change-password", { current_password, new_password });
export const updateProfile = (data) => api.put("/auth/profile", data);

// Admin
export const deleteUser = (userId) => api.delete(`/admin/users/${userId}`);

// Properties
export const getProperties = () => api.get("/properties");
export const getProperty = (id) => api.get(`/properties/${id}`);
export const createProperty = (data) => api.post("/properties", data);
export const updateProperty = (id, data) => api.put(`/properties/${id}`, data);
export const deleteProperty = (id) => api.delete(`/properties/${id}`);

// Expenses
export const getExpenses = (propertyId) => api.get(`/expenses/${propertyId}`);
export const createExpense = (data) => api.post("/expenses", data);
export const deleteExpense = (id) => api.delete(`/expenses/${id}`);

// Cashflow
export const getCashflow = (propertyId, taxableIncome = null) => {
  const params = taxableIncome ? `?taxable_income=${taxableIncome}` : '';
  return api.get(`/cashflow/${propertyId}${params}`);
};

// Portfolio
export const getPortfolioSummary = () => api.get("/portfolio/summary");

// Forecasting
export const forecastProperty = (propertyId, settings) => 
  api.post(`/forecast/${propertyId}`, settings);
export const forecastPortfolio = (settings) => 
  api.post("/forecast/portfolio", settings);

// Tax
export const calculateStampDuty = (price, state) => 
  api.get(`/tax/stamp-duty?price=${price}&state=${state}`);
export const calculateLandTax = (propertyId) => 
  api.get(`/tax/land-tax/${propertyId}`);
export const calculateCGT = (data) => api.post("/tax/cgt", data);

// Recommendations
export const getRecommendations = () => api.get("/recommendations");

// Format currency
export const formatCurrency = (value) => {
  if (value === null || value === undefined) return "$0";
  return new Intl.NumberFormat("en-AU", {
    style: "currency",
    currency: "AUD",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);
};

// Format percentage
export const formatPercent = (value) => {
  if (value === null || value === undefined) return "0%";
  return `${value.toFixed(1)}%`;
};

// Purchase types for stamp duty
export const PURCHASE_TYPES = [
  { value: "ppor", label: "Principal Place of Residence (PPOR)" },
  { value: "investment", label: "Investment Property" },
  { value: "company", label: "Company Structure" },
  { value: "trust", label: "Trust Structure" },
  { value: "smsf", label: "SMSF" },
];

// Calculate stamp duty with purchase type
export const calculateStampDutyAdvanced = (data) => 
  api.post("/tax/stamp-duty", data);

// Australian states
export const STATES = [
  { value: "NSW", label: "New South Wales" },
  { value: "VIC", label: "Victoria" },
  { value: "QLD", label: "Queensland" },
  { value: "SA", label: "South Australia" },
  { value: "WA", label: "Western Australia" },
  { value: "TAS", label: "Tasmania" },
  { value: "NT", label: "Northern Territory" },
  { value: "ACT", label: "Australian Capital Territory" },
];

// Property types
export const PROPERTY_TYPES = [
  { value: "house", label: "House" },
  { value: "unit", label: "Unit/Apartment" },
  { value: "townhouse", label: "Townhouse" },
  { value: "land", label: "Land" },
  { value: "commercial", label: "Commercial" },
];

// Expense categories
export const EXPENSE_CATEGORIES = [
  { value: "council_rates", label: "Council Rates" },
  { value: "water", label: "Water Rates" },
  { value: "insurance", label: "Insurance" },
  { value: "management_fees", label: "Property Management" },
  { value: "repairs", label: "Repairs & Maintenance" },
  { value: "strata", label: "Strata/Body Corp" },
  { value: "other", label: "Other" },
];

// Frequency options
export const FREQUENCIES = [
  { value: "weekly", label: "Weekly" },
  { value: "monthly", label: "Monthly" },
  { value: "quarterly", label: "Quarterly" },
  { value: "annually", label: "Annually" },
];
